import {
  array,
  InferInput,
  InferOutput,
  object,
  pipe,
  safeParse,
  string,
  ValiError,
} from 'valibot';
import { RecommendList, RecommendListSchema } from '../apiSchema.ts';

export const RecommendationRequestArgsSchema = object({
  id: string(),
});

export const MeRecommendationsResponseSchema = pipe(
  object({
    data: array(RecommendListSchema),
  }),
);

export const MeRecommendationsIdAPISchema = object({
  data: MeRecommendationsResponseSchema,
});

export type RecommendationRequestArgs = InferOutput<
  typeof RecommendationRequestArgsSchema
>;

export type MeRecommendationsIdAPI = InferInput<
  typeof MeRecommendationsIdAPISchema
>;

/**
 * Fetches the recommendations for the user.
 * @param {MusicKit.MusicKitInstance} player The MusicKit instance.
 * @param {RecommendationRequestArgs} params The parameters for the request.
 * @returns {Promise<RecommendList>} The response data.
 */
export const $getMeRecommendationsId = async (
  player: MusicKit.MusicKitInstance,
  params: RecommendationRequestArgs,
): Promise<RecommendList> => {
  const p = safeParse(
    RecommendationRequestArgsSchema,
    params,
  );
  if (!p.success) {
    throw new ValiError(p.issues);
  }
  const { id } = p.output;
  const res = await player.api.music(
    `/v1/me/recommendations/${id}`,
  ) as unknown as MeRecommendationsIdAPI;
  const r = safeParse(
    MeRecommendationsIdAPISchema,
    res,
  );
  if (!r.success) {
    throw new ValiError(r.issues);
  }

  const { data } = r.output.data;
  if (!data || data.length === 0) {
    throw new Error('No recommendations found');
  }
  const recommendList = data[0];
  return recommendList;
};
